import './index.css';

import Landing from './Page Sections/Landing/Landing';
import About from './Page Sections/About/About';

function App() {
  return (
    <div className="App">

      <Landing />

      <About />

      <footer>
        <p>@ Created by Alex Benta, 2022</p>
      </footer>
    </div>
  );
}

export default App;
